import { render, staticRenderFns } from "./DialogInvoice.vue?vue&type=template&id=b537fb6a&scoped=true"
import script from "./DialogInvoice.vue?vue&type=script&lang=js"
export * from "./DialogInvoice.vue?vue&type=script&lang=js"
import style0 from "./DialogInvoice.vue?vue&type=style&index=0&id=b537fb6a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b537fb6a",
  null
  
)

export default component.exports